export class BaseError extends Error {
    constructor(title, message, httpStatusCode, logSeverity, redirectUrl){
        super(message.key), this.logError = true;
        this.title = title;
        this.description = message;
        this.httpStatusCode = httpStatusCode;
        this.logSeverity = logSeverity;
        this.redirectUrl = redirectUrl;
    }
}
